import * as React from 'react';
import { FilterBar } from './components/FilterBar';
import { KeyMetricSection } from './components/KeyMetricSection';
import { OverTimeSection } from './components/OverTimeSection';
import { BreakdownSection } from './components/BreakdownSection';

export const HistoricalPerDiem: React.FC = () => {
  return (
    <div className="flex flex-col space-y-8 flex-grow pb-32">
      <FilterBar />
      <KeyMetricSection />
      <OverTimeSection />
      <BreakdownSection />
    </div>
  );
};
HistoricalPerDiem.displayName = 'Shipments.HistoricalPerDiem';
